import { useNavigate } from "react-router-dom";

export default function CTASection() {
    const navigate = useNavigate();

    return (
        <section className="relative overflow-hidden bg-white py-10 sm:py-12 lg:py-14">
            <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">

                {/* =====================================================
                    CTA CONTAINER
                ====================================================== */}
                <div className="relative overflow-hidden rounded-[28px] bg-[#002B45] px-6 py-10 shadow-[0_20px_60px_rgba(0,43,69,0.18)] sm:px-10 sm:py-12 lg:px-16 lg:py-14">

                    {/* Background gradients */}
                    <div className="pointer-events-none absolute -right-20 -top-32 h-80 w-80 rounded-full bg-[#174EA6] opacity-40 blur-3xl" />

                    <div className="pointer-events-none absolute -bottom-32 -left-20 h-72 w-72 rounded-full bg-[#FFC928] opacity-10 blur-3xl" />

                    {/* Decorative circles */}
                    <div className="pointer-events-none absolute right-10 top-8 h-24 w-24 rounded-full border border-white/10" />

                    <div className="pointer-events-none absolute right-20 top-16 h-10 w-10 rounded-full bg-[#FFC928]/10" />

                    {/* Gold top accent */}
                    <div className="absolute left-0 right-0 top-0 h-1 bg-gradient-to-r from-[#174EA6] via-[#FFC928] to-[#174EA6]" />

                    <div className="relative z-10 flex flex-col items-center justify-between gap-8 lg:flex-row">

                        {/* =================================================
                            CONTENT
                        ================================================== */}
                        <div className="max-w-2xl text-center lg:text-left">

                            {/* Eyebrow */}
                            <div className="mb-3 flex items-center justify-center gap-2 lg:justify-start">
                                <span className="h-[2px] w-6 rounded-full bg-[#FFC928]" />

                                <span className="text-[10px] font-bold uppercase tracking-[0.18em] text-[#FFC928]">
                                    Your Dubai Stay Awaits
                                </span>
                            </div>

                            {/* Heading */}
                            <h2 className="text-2xl font-extrabold leading-tight !text-white sm:text-3xl lg:text-[36px]">
                                Ready to Find Your{" "}
                                <span className="text-[#FFC928]">
                                    Perfect Stay?
                                </span>
                            </h2>

                            {/* Description */}
                            <p className="mt-3 max-w-xl text-sm leading-6 text-white/70 sm:text-base">
                                Discover the best hotels in Dubai, compare
                                your options and book your next unforgettable
                                stay with confidence.
                            </p>

                            {/* Trust points */}
                            <div className="mt-5 flex flex-wrap items-center justify-center gap-x-5 gap-y-2 lg:justify-start">

                                <div className="flex items-center gap-1.5 text-xs font-medium text-white/80">
                                    <span className="flex h-5 w-5 items-center justify-center rounded-full bg-[#FFC928] text-[#002B45]">
                                        ✓
                                    </span>
                                    Best Hotel Deals
                                </div>

                                <div className="flex items-center gap-1.5 text-xs font-medium text-white/80">
                                    <span className="flex h-5 w-5 items-center justify-center rounded-full bg-[#FFC928] text-[#002B45]">
                                        ✓
                                    </span>
                                    Trusted Booking
                                </div>

                                <div className="flex items-center gap-1.5 text-xs font-medium text-white/80">
                                    <span className="flex h-5 w-5 items-center justify-center rounded-full bg-[#FFC928] text-[#002B45]">
                                        ✓
                                    </span>
                                    24/7 Support
                                </div>

                            </div>
                        </div>

                        {/* =================================================
                            CTA BUTTONS
                        ================================================== */}
                        <div className="flex w-full shrink-0 flex-col items-center gap-3 sm:w-auto sm:flex-row">

                            {/* Primary */}
                            <button
                                onClick={() => navigate("/hotels")}
                                className="group flex w-full items-center justify-center gap-2 rounded-xl bg-[#FFC928] px-7 py-3.5 text-sm font-extrabold text-[#002B45] shadow-[0_10px_25px_rgba(255,201,40,0.20)] transition-all duration-300 hover:-translate-y-1 hover:bg-[#FFD84D] hover:shadow-[0_15px_30px_rgba(255,201,40,0.28)] sm:w-auto"
                            >
                                <span>Explore Hotels</span>

                                <span className="transition-transform duration-300 group-hover:translate-x-1">
                                    →
                                </span>
                            </button>

                            {/* Secondary */}
                            <button
                                onClick={() => navigate("/destinations")}
                                className="group flex w-full items-center justify-center gap-2 rounded-xl border border-white/20 bg-white/5 px-7 py-3.5 text-sm font-bold text-white backdrop-blur-sm transition-all duration-300 hover:-translate-y-1 hover:border-white/40 hover:bg-white/10 sm:w-auto"
                            >
                                <span>Explore Destinations</span>

                                <span className="transition-transform duration-300 group-hover:translate-x-1">
                                    →
                                </span>
                            </button>

                        </div>
                    </div>

                    {/* Bottom decorative line */}
                    <div className="absolute bottom-0 left-1/2 h-px w-2/3 -translate-x-1/2 bg-gradient-to-r from-transparent via-white/10 to-transparent" />
                </div>
            </div>
        </section>
    );
}